import get from 'lodash/get';
import isArray from 'lodash/isArray';

import Http from '../../http';
import * as types from './constants';

export function getBankAccount(endpoint) {
  return (dispatch) => {
    dispatch({ type: types.REQUEST_BANK_ACCOUNT });

    return Http.get(endpoint).then((data) => {
      // API is currently sending array instead of single item. Remove on API update.
      const bankAccount = isArray(data) ? get(data, '[0]', null) : data;
      dispatch({ type: types.IMPORT_BANK_ACCOUNT, bankAccount });
      return bankAccount;
    });
  };
}

export function getShopBankAccount(shopId) {
  const endpoint = `/shop/${shopId}/bank-account`;
  return getBankAccount(endpoint);
}

export function getBarberBankAccount(barberId) {
  const endpoint = `/barber/${barberId}/bank-account`;
  return getBankAccount(endpoint);
}

function addBankAccount(endpoint, data) {
  return dispatch => Http.post(endpoint, data).then((bankAccount) => {
    dispatch({ type: types.IMPORT_BANK_ACCOUNT, bankAccount });
    return bankAccount;
  });
}

export function addBarberBankAccount(barberId, data) {
  const endpoint = `/barber/${barberId}/bank-account`;
  return addBankAccount(endpoint, data);
}

export function addShopBankAccount(shopId, data) {
  const endpoint = `/shop/${shopId}/bank-account`;
  return addBankAccount(endpoint, data);
}

export function updateBankAccount(endpoint, data) {
  return dispatch => Http.put(endpoint, data).then((bankAccount) => {
    dispatch({ type: types.IMPORT_BANK_ACCOUNT, bankAccount });
    return bankAccount;
  });
}

export function updateShopBankAccount(shopId, data) {
  const endpoint = `/shop/${shopId}/bank-account`;
  return updateBankAccount(endpoint, data);
}

export function uploadBankAccountDocuments(ownerId, ownerType, documents) {
  const endpoint = `/${ownerType}/${ownerId}/bank-account/documents`;
  return Http.putRaw(endpoint, documents);
}

export function updateBarberBankAccount(barberId, data) {
  const endpoint = `/barber/${barberId}/bank-account`;
  return updateBankAccount(endpoint, data);
}

export function deleteBankAccount(endpoint) {
  return dispatch => Http.delete(endpoint).then((bankAccount) => {
    dispatch({ type: types.DELETE_BANK_ACCOUNT, bankAccount });
    return bankAccount;
  });
}

export function deleteShopBankAccount(shopId) {
  const endpoint = `/shop/${shopId}/bank-account`;
  return deleteBankAccount(endpoint);
}

export function deleteBarberBankAccount(barberId) {
  const endpoint = `/barber/${barberId}/bank-account`;
  return deleteBankAccount(endpoint);
}

export const addDebitCardAction = data => ({
  type: types.ADD_DEBIT_CARD,
  payload: data,
});

const addDebitCard = (url, data) => dispatch =>
  Http.post(url, data)
    .then((debitCard) => {
      dispatch(addDebitCardAction(debitCard));
      return debitCard;
    });

export const addBarberDebitCard = (id, data) => addDebitCard(`/barber/${id}/debit-card`, data);

export const addShopDebitCard = (id, data) => addDebitCard(`/shop/${id}/debit-card`, data);

const deleteDebitCardAction = () => ({
  type: types.DELETE_DEBIT_CARD,
});

const deleteDebitCard = url => dispatch =>
  Http.delete(url)
    .then(() => dispatch(deleteDebitCardAction()));

export const deleteBarberDebitCard = id => deleteDebitCard(`/barber/${id}/debit-card`);

export const deleteShopDebitCard = id => deleteDebitCard(`/shop/${id}/debit-card`);

const requestDebitCardAction = payload => ({
  type: types.REQUEST_DEBIT_CARD,
  payload,
});

const requestDebitCard = url => dispatch =>
  Http.get(url)
    .then(debitCard => dispatch(requestDebitCardAction(debitCard)))
    .catch(() => {});

export const requestBarberDebitCard = id => requestDebitCard(`/barber/${id}/debit-card`);

export const requestShopDebitCard = id => requestDebitCard(`/shop/${id}/debit-card`);

const updateDebitCardAction = payload => ({
  type: types.UPDATE_DEBIT_CARD,
  payload,
});

const updateDebitCardStartAction = {
  type: types.UPDATE_DEBIT_CARD_START,
};

const updateDebitCardErrorAction = {
  type: types.UPDATE_DEBIT_CARD_ERROR,
};

const updateDebitCard = (url, data) => (dispatch) => {
  dispatch(updateDebitCardStartAction);

  return Http.put(url, data)
    .then(debitCard => dispatch(updateDebitCardAction(debitCard)))
    .catch((err) => {
      dispatch(updateDebitCardErrorAction);
      throw err;
    });
};

export const updateBarberDebitCard = (id, data) => updateDebitCard(`/barber/${id}/debit-card`, data);
export const updateShopDebitCard = (id, data) => updateDebitCard(`/shop/${id}/debit-card`, data);

const merchantInfoRecieved = info => ({
  type: types.SET_MERCHANT_INFO,
  payload: info,
});

export const getShopMerchantInfo = id => dispatch =>
  Http.get(`/shop/${id}/pos-merchant`)
    .then(info => dispatch(merchantInfoRecieved(info)));

export const getBarberMerchantInfo = id => dispatch =>
  Http.get(`/barber/${id}/pos-merchant`)
    .then(info => dispatch(merchantInfoRecieved(info)));


const fetchBalanceAction = balance => ({
  type: types.FETCH_BALANCE,
  payload: balance,
});
const fetchBalance = url => dispatch =>
  Http.get(url)
    .then(balance => dispatch(fetchBalanceAction(balance)));
export const fetchBarberBalance = id => fetchBalance(`/barber/${id}/bank-account/balance`);
export const fetchShopBalance = id => fetchBalance(`/shop/${id}/bank-account/balance`);

const initiateInstantPayout = url => (dispatch) => {
  dispatch({ type: types.INITIATE_INSTANT_PAYOUT });
  return Http.post(url);
};

export const initiateBarberInstantPayout = id => initiateInstantPayout(`/barber/${id}/instant-payout`);
export const initiateShopInstantPayout = id => initiateInstantPayout(`/shop/${id}/instant-payout`);

const fetchPaymentCardAction = payload => ({
  type: types.FETCH_SUBSCRIPTION_PAYMENT_CARD,
  payload,
});

export const fetchShopPaymentCard = shopId => async (dispatch) => {
  const result = await Http.get(`/shop/${shopId}/payment-card`);

  return dispatch(fetchPaymentCardAction(result));
};

export const fetchBarberPaymentCard = barberId => async (dispatch) => {
  const result = await Http.get(`/barber/${barberId}/payment-card`);

  return dispatch(fetchPaymentCardAction(result));
};

const updatePaymentCardAction = payload => ({
  type: types.UPDATE_SUBSCRIPTION_PAYMENT_CARD,
  payload,
});

export const updateShopPaymentCard = (shopid, data) => async (dispatch) => {
  const result = await Http.put(`/shop/${shopid}/payment-card`, data);

  return dispatch(updatePaymentCardAction(result));
};

export const updateBarberPaymentCard = (barberId, data) => async (dispatch) => {
  const result = await Http.put(`/barber/${barberId}/payment-card`, data);

  return dispatch(updatePaymentCardAction(result));
};
